// export DsfSubTable from "./subTable.vue";
// export DsfSubTableColumn from "./subTableColumn.vue";
// export DsfSubTableCellContent from "./subTableCellContent.vue";
// export DsfSubTable from "./subTable.vue";
export const DsfSubTable = dsf.defineAsyncComponent("DsfSubTable", () =>
  import(/*webpackChunkName:"platform_pc_subtable"*/ "./subTable.vue")
);
// 子表块状组件
export const DsfSubTableBlock = dsf.defineAsyncComponent("DsfSubTableBlock", () => {
  return dsf.requestAsyncComponents(DsfSubTable).then((res) => {
    return import(/* webpackChunkName: "platform_pc_subtable" */ "./subTableBlock.vue");
  });
});
export const DsfSubTableColumn = dsf.defineLazyComponent("DsfSubTableColumn", () =>
  require("./subTableColumn.vue")
);
export const DsfSubTableCellContent = dsf.defineLazyComponent("DsfSubTableCellContent", () =>
  require("./subTableCellContent.vue")
);
